import type MruFolderCache from "./schema/MoveToFolderMruState";
import { createStore } from "owa-satcheljs";
import type { MailboxInfo } from "owa-client-types";
import { getMailboxKeyForMailboxInfo } from "owa-client-types";
import getMoveToMruMailboxInfo from "../utils/getMoveToMruMailboxInfo";

const mruFolders = new Map<string, MruFolderCache>();

export default function store(mailboxInfoInput: MailboxInfo): MruFolderCache {
    const mailboxInfo = getMoveToMruMailboxInfo(mailboxInfoInput);
    const name = `${getMailboxKeyForMailboxInfo(mailboxInfo)}_mruFolderCache`;
    let cachedStore = mruFolders.get(name);
    if (!cachedStore) {
        const initialStore: MruFolderCache = {
            mruFolders: [],
            isInitialized: false,
        };
        
        /* eslint-disable-next-line owa-custom-rules/invoke-only-in-module-scope -- (https://aka.ms/OWALintWiki)
         * Baseline. DO NOT COPY AND PASTE!, this function can only be called in the module scope.
         *	> Function should only be invoked in module scope */
        const mruFolderStore = createStore<MruFolderCache>(name, initialStore)();
        mruFolders.set(name, mruFolderStore);
        cachedStore = mruFolderStore;
    }
    
    return cachedStore;
}
